export function formatDate(dateStr) {
  if (!dateStr) return null;
  const datePart = String(dateStr).split("T")[0];
  const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, y, m, d] = match;
    return `${d}/${m}/${y}`;
  }
  const d2 = new Date(dateStr);
  if (isNaN(d2.getTime())) return null;
  const dd = String(d2.getDate()).padStart(2, "0");
  const mm = String(d2.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d2.getFullYear()}`;
}

const CLOSED_STATUSES = ["Released", "Adopted", "Sanctuary Resident", "Passed Away"];

export function daysUnderCareLabel(caseItem) {
  if (caseItem.days_since_admission == null) return "Admission date missing";
  const days = caseItem.days_since_admission;
  if (CLOSED_STATUSES.includes(caseItem.status)) return `Under care for ${days} days`;
  return `${days} days under care`;
}

function daysAtSanctuary(arrivalDateStr) {
  if (!arrivalDateStr) return null;
  const arrival = new Date(arrivalDateStr);
  if (isNaN(arrival.getTime())) return null;
  const days = Math.floor((Date.now() - arrival.getTime()) / 86400000);
  return Math.max(days, 0);
}

// Warm, human-readable duration for donor-facing pages: "2 years at our
// sanctuary" (1+ years), "8 months at our sanctuary" (under a year), "3 weeks
// at our sanctuary" (under a month).
export function timeAtSanctuaryLabel(arrivalDateStr) {
  const days = daysAtSanctuary(arrivalDateStr);
  if (days == null) return "At our sanctuary";
  const years = Math.floor(days / 365);
  if (years >= 1) return `${years} year${years > 1 ? "s" : ""} at our sanctuary`;
  const months = Math.floor(days / 30);
  if (months >= 1) return `${months} month${months > 1 ? "s" : ""} at our sanctuary`;
  const weeks = Math.floor(days / 7);
  if (weeks >= 1) return `${weeks} week${weeks > 1 ? "s" : ""} at our sanctuary`;
  return days === 1 ? "1 day at our sanctuary" : `${days} days at our sanctuary`;
}

// Exact day count for the internal staff view.
export function exactDaysAtSanctuaryLabel(arrivalDateStr) {
  const days = daysAtSanctuary(arrivalDateStr);
  if (days == null) return "Arrival date unknown";
  return `${days} day${days === 1 ? "" : "s"} at sanctuary`;
}
